import { Injectable } from "@angular/core";
import {
  AlertController,
  LoadingController,
  ToastController,
} from "ionic-angular";
import { Api } from "./api";
import { User } from "./user";
import { env } from "../config/environment";

@Injectable()
export class Poster {
  constructor(
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private api: Api,
    public user: User
  ) {}

  show(item_id, tenantId = 1) {
    return new Promise((resolve, reject) => {
      const posterData = {
        item_id,
        user_id: this.user.id,
      };

      this.api.getSharePoster(posterData, false, true).then((data) => {
        if (!data.fileName) {
          return;
        }
        // setTimeout(() => {
        //   let element = window.document.getElementsByClassName("get-invitation-poster-btn")[0];
        //   (element as any).style.height = "80px";
        //   element.innerHTML = "获得我的邀请海报<br/><div style='transform: scale(0.85);font-size: 12px;font-weight: normal;line-height: 15px;margin-top: 4px;color: #777;'>您的好友在11月20日前消费，您将获得现金奖励。在此日期之后，您将获得代金券</div>"
        // });
        this.alertCtrl
          .create({
            title: "邀请好友加入一起学习<br/>获得奖励",
            message: `${
              !!data.desc ? `<div class="poster-desc">${data.desc}</div>` : ``
            }<img src='${this.getUrl(data.fileName)}' alt="poster"/>`,
            subTitle: ``,
            buttons: [
              {
                text: "获得我的邀请海报",
                cssClass: "font-weight-bold get-invitation-poster-btn",
                handler: () => {
                  if (tenantId === 2) {
                    window.location.hash =
                      "tybshare/___" +
                      urlSafeBase64Encode(JSON.stringify(posterData));
                  } else {
                    window.location.hash =
                      "dtbshare/___" +
                      urlSafeBase64Encode(JSON.stringify(posterData));
                  }
                },
              },
              {
                text: "不了",
                cssClass: "font-weight-normal",
                role: "cancel",
                handler: () => {
                  resolve(false);
                },
              },
            ],
          })
          .present();
      });
    });
  }

  getUrl(fileName: string) {
    return `${env.server_url}posters/${fileName}`;
  }
}

function urlSafeBase64Encode(value) {
  return btoa(value)
    .split("=")
    .join(".")
    .split("/")
    .join("-")
    .split("+")
    .join("_");
}



// WEBPACK FOOTER //
// ./src/services/poster.ts